import { ActionReducerMapBuilder, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { getCasesProfile, patchCasesProfile, postCasesProfile } from "./thunks";
import { CasesProfile } from "../../../entities/cases_v2";

interface CasesProfileState {
  loading: boolean,
  saveLoading: boolean,
  profile?: CasesProfile,
}

const initialState: CasesProfileState = {
  loading: false,
  saveLoading: false,
}

const saveCases = (
  builder: ActionReducerMapBuilder<CasesProfileState>,
  action: any
) => {
  builder.addCase(action.pending, (state: CasesProfileState) => {
    state.saveLoading = true;
  });

  builder.addCase(action.fulfilled, (state: CasesProfileState, action: PayloadAction<CasesProfile>) => {
    state.saveLoading = false;
    state.profile = action.payload;
  });
  builder.addCase(action.rejected, (state: CasesProfileState) => {
    state.saveLoading = false;
  });
};

export const casesProfileStore = createSlice({
  name: "casesProfile",
  initialState: initialState,
  reducers: {
    clearProfile: (state) => {
      state.profile = undefined;
    }
  },
  extraReducers: (builder) => {
    // getWheelProfile
    builder.addCase(getCasesProfile.pending, state => {
      state.loading = true;
    })
    builder.addCase(getCasesProfile.fulfilled, (state, action) => {
      state.profile = action.payload;

      state.loading = false;
    })
    const saveActions = [postCasesProfile,
      patchCasesProfile];

    saveActions.forEach((action) => { saveCases(builder, action) })
  },
})

export const { clearProfile } = casesProfileStore.actions

export default casesProfileStore.reducer;